import { memo } from "react";
import { sectionTabs } from "../../../consts/tabs";

import { SectionMenu } from "../components/SectionMenu";
import { SectionDetail } from "../../SectionDetail";

export const SectionManagementSections = memo(() => {
  return (
    <SectionMenu tabs={sectionTabs}>
      <SectionMenu.SectionMenuItem id={0}>
        <SectionDetail />
      </SectionMenu.SectionMenuItem>
    </SectionMenu>
  );
});
